/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `fetchAssetsGuard` for the Caintra Connect frontend.
 * @module utils/fetchAssetsGuard
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import { getApiBaseUrl, restoreIncomingAssets } from "./assetUrl";

const originalFetch = window.fetch.bind(window);

const requestUrl = (input) => {
  if (typeof input === "string") {
    return input;
  }
  if (input instanceof URL) {
    return input.href;
  }
  return input?.url || "";
};

const isApiJsonRequest = (input) => {
  const url = requestUrl(input);
  const api = getApiBaseUrl();
  return Boolean(url) && Boolean(api) && url.startsWith(api);
};

window.fetch = (input, init = {}) => {
  if (isApiJsonRequest(input) && init.body && typeof init.body === "string") {
    try {
      const parsed = JSON.parse(init.body);
      init = {
        ...init,
        body: JSON.stringify(restoreIncomingAssets(parsed)),
      };
    } catch {
      // Non-JSON bodies stay untouched.
    }
  }
  return originalFetch(input, init);
};
